// DS: i7.7
import React from 'react';
import IconWrap from '../../IconWrap';
const EditorAlignLeft = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M5 5a1 1 0 100 2h9a1 1 0 100-2H5zM4 18a1 1 0 001 1h9a1 1 0 100-2H5a1 1 0 00-1 1zm0-6a1 1 0 001 1h14a1 1 0 100-2H5a1 1 0 00-1 1z",
        clipRule: "evenodd"
    })));
};
EditorAlignLeft.displayName = 'EditorAlignLeft';
export default EditorAlignLeft;

//# sourceMappingURL=EditorAlignLeft.js.map